import {
   ApplicationPropertyType,
   GetSearchAndMonitoringConfigResult
} from '@flowwai-frontend/bps-officer-web/graphql'
import { UnionFieldType } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import {
   FilterFieldsConfigType,
   FilterFieldsResponsesConfigType
} from '../types/filterTypes'

export const convertGqlSearchAndMonitoringConfigToFilterFieldsConfigType = (
   config: GetSearchAndMonitoringConfigResult
): FilterFieldsConfigType => ({
   fields: config.fields ?? [],
   filterFieldIds: config.filterFields.map(field => field.fieldId),
   overviewFieldIds: config.overviewFieldIds
})

export const convertPropertyTypeNameIntoUnionFieldType = (
   propertyType: ApplicationPropertyType
): UnionFieldType => {
   switch (propertyType) {
      case ApplicationPropertyType.CheckboxGroup: {
         return 'CHECKBOX_GROUP'
      }
      case ApplicationPropertyType.DateTime: {
         return 'DATE_TIME'
      }
      case ApplicationPropertyType.Date: {
         return 'DATE'
      }
      case ApplicationPropertyType.Dropdown: {
         return 'DROPDOWN'
      }
      case ApplicationPropertyType.Email: {
         return 'EMAIL'
      }
      case ApplicationPropertyType.Float: {
         return 'FLOAT'
      }
      case ApplicationPropertyType.Integer: {
         return 'INTEGER'
      }
      case ApplicationPropertyType.RadioGroup: {
         return 'RADIO_GROUP'
      }
      case ApplicationPropertyType.Time: {
         return 'TIME'
      }
      case ApplicationPropertyType.GeoLocation: {
         return 'GEO_LOCATION'
      }
      case ApplicationPropertyType.GeoShape: {
         return 'GEO_SHAPE'
      }
      case ApplicationPropertyType.LongText: {
         return 'LONG_TEXT'
      }
      case ApplicationPropertyType.MultiSelect: {
         return 'MULTI_SELECT'
      }
      case ApplicationPropertyType.PhoneNumber: {
         return 'PHONE_NUMBER'
      }
      case ApplicationPropertyType.PlainText: {
         return 'PLAIN_TEXT'
      }
      case ApplicationPropertyType.ShortText: {
         return 'SHORT_TEXT'
      }
      case ApplicationPropertyType.Url: {
         return 'URL'
      }

      default: {
         return 'PLAIN_TEXT'
      }
   }
}

export const getFormattedFilterFieldsConfigFromParsedConfig = (
   config: FilterFieldsResponsesConfigType[]
): FilterFieldsResponsesConfigType[] =>
   config.map(eachConfig => {
      switch (eachConfig.fieldType) {
         case 'DATE_TIME':
         case 'DATE': {
            const response = eachConfig.response as any
            return {
               ...eachConfig,
               response: response ? new Date(response) : null
            }
         }
         default:
            return {
               ...eachConfig
            }
      }
   })
